import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Stack from '@mui/material/Stack';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import ArrowDownIcon from '@pok/weblib/ui/ArrowDownIcon.jsx';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { getDownloadFormat, saveDownloadFormat } from '../utils/sessionStorage.js';

export default function DownloadFormatCombo({ certificateId, wallet, disabled }) {
    const { t } = useTranslation();
    const [supportedFormats] = useState([
        {
            key: 'pdf',
            label: 'pdf',
        },
        {
            key: 'png',
            label: 'png',
        },
    ]);
    const [anchorFormatCombo, setAnchorFormatCombo] = useState(null);
    let currentSelectedFormat = 'pdf';

    if (getDownloadFormat(certificateId, wallet)) {
        currentSelectedFormat = getDownloadFormat(certificateId, wallet);
    } else {
        saveDownloadFormat(certificateId, wallet, currentSelectedFormat);
    }

    const handleComboClick = (event) => {
        setAnchorFormatCombo(event.currentTarget);
        event.stopPropagation();
        event.preventDefault();
    };

    const handleComboClose = () => {
        setAnchorFormatCombo(null);
    };

    const onFormatClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const selectedFormat = e.currentTarget.dataset.fmt;
        saveDownloadFormat(certificateId, wallet, selectedFormat);
        handleComboClose();
    };

    return (
        <>
            <Stack
                direction={'row'}
                onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                }}
                sx={{
                    cursor: 'pointer',
                    alignSelf: 'center',
                    borderRadius: '4px',

                    backgroundColor: disabled ? '#EFEFEF' : '#5124A61A',
                }}
            >
                <IconButton
                    component={'div'}
                    aria-haspopup="true"
                    onClick={handleComboClick}
                    sx={{
                        p: { xs: '6px', sm: '1px' },
                        ml: { xs: 0, sm: 1 },
                        mr: { sx: 4, md: 0 },
                        height: '32px',
                        color: 'inherit',
                    }}
                >
                    <Typography variant="bodyMenu" ml={2} alignSelf={'center'} sx={{ marginRight: '10px' }}>
                        {currentSelectedFormat}
                    </Typography>
                    <Stack sx={{ display: { xs: 'none', md: 'inline' }, mt: '6px' }}>
                        <ArrowDownIcon fill={disabled ? '#CCC9D1' : '#5124A6'} />
                    </Stack>
                </IconButton>
            </Stack>
            <Menu
                onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                }}
                anchorEl={anchorFormatCombo}
                open={Boolean(anchorFormatCombo)}
                onClose={handleComboClose}
                slotProps={{
                    paper: {
                        sx: {
                            width: { xs: '101px', md: '101px' },
                            left: '1200px',
                        },
                    },
                }}
            >
                {supportedFormats.map((format) => (
                    <MenuItem onClick={onFormatClick} key={t(format.key)} data-fmt={format.key}>
                        <Stack direction={'row'} spacing={2}>
                            <Typography variant="body2" ml={2} alignSelf={'center'} fontWeight={500}>
                                {t(format.key)}
                            </Typography>
                        </Stack>
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
}
